//import * as Helper from "../../../utils/Helper";
import ApiService from "../../ApiService";

const SettingService = {
    loadScreenView: (successCallback, failureCallback) => {
        ApiService.post("/web/admin/setting/loadscreenview", {}, successCallback, failureCallback);
    },
    updateSetting: (key, value, successCallback, failureCallback) => {
        ApiService.post("/web/admin/setting/updateSetting", { key, value }, successCallback, failureCallback);
    },

    getAllFeatures: (successCallback, failureCallback) => {
        ApiService.post("/web/admin/setting/getallfeatures", {}, successCallback, failureCallback);
    },
    updateFeature: (vo, successCallback, failureCallback) => {
        ApiService.post("/web/admin/setting/updatefeature", vo, successCallback, failureCallback);
    },
    getFeatureConfiguration: (id, successCallback, failureCallback) => {
        ApiService.post("/web/admin/setting/getfeatureconfiguration", { id }, successCallback, failureCallback);
    },

    resetChineseParkData: (successCallback, failureCallback) => {
        ApiService.post("/web/admin/setting/resetchineseparkdata", {}, successCallback, failureCallback);
    },
};

export default SettingService;